import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { CommonModule } from '@angular/common';
import { IncomingOutgoingComponent } from './incoming-outgoing.component';
import { DirectivesModule } from '../../../components/directives.module';

const ROUTES: Routes = [
  { path: '', component: IncomingOutgoingComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    RouterModule.forChild(ROUTES),
    AgGridAngular,
  ],
  declarations: [IncomingOutgoingComponent],
  exports: [IncomingOutgoingComponent],
})
export class IncomingOutgoingModule {}
